import React, { useEffect } from 'react'
import HomeBanner from '../Components/HomeBanner'
import HomeCards from '../Components/HomeCards'
import HomeCaringDoctors from '../Components/HomeCaringDoctors'
import HomeComprehensiveCare from '../Components/HomeComprehensiveCare'
import Appointment from '../Components/Appointment'
import HomeOnSite from '../Components/HomeOnSite'
import Testmonials from '../Components/Testmonials'
import HomeArticles from '../Components/HomeArticles'
import HomeContact from '../Components/HomeContact'
import BookAnAppointMent from '../Components/bookform'

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='overflow-hidden '>
      <title>
        MagnAid Hospital | Multi Speciality Hospital in Hyderabad
      </title>
      <meta name="description" content="MagnAid Hospitals,Hyderabad's best multispecialty hospital,delivering 24/7 expert care with advanced facilities and a commitment to patient well-being.Book now!" />
      <HomeBanner />
      <HomeComprehensiveCare />
      <BookAnAppointMent />
      <HomeCaringDoctors />
      <HomeOnSite />
      <Appointment />
      <HomeCards />
      <Testmonials />
      <HomeArticles />
      <HomeContact />
    </div>
  )
}
